import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  inspectorData: [],
  inspectorDetails: null,
  totalCount: 0,
  error: null,
  currentPage: 1,
  uploadedFiles: [],
  isUploading: false,
  itemsPerPage: 10,
};

const addInspectorSlice = createSlice({
  name: "inspector",
  initialState,
  reducers: {
    addInspectorStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    addInspectorSuccess(state, action) {
      if (Array.isArray(state.inspectorData)) {
        state.inspectorData.push(action.payload.result);
        state.totalCount += 1;
      } else {
        console.error(
          "Expected inspectorData to be an array but got:",
          state.inspectorData
        );
      }
    },
    addInspectorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchInspectorStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchInspectorSuccess(state, action) {
      state.isLoading = false;
      state.inspectorData = action.payload.data;
      state.totalCount = action.payload.totalCount;
      state.error = null;
    },
    fetchInspectorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchInspectorDetailsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchInspectorDetailsSuccess(state, action) {
      state.isLoading = false;
      state.inspectorDetails = action.payload;
      state.error = null;
    },
    fetchInspectorDetailsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    blockInspectorStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    blockInspectorSuccess(state, action) {
      state.isLoading = false;
      state.inspectorDetails = action.payload;
      state.error = null;
    },

    blockInspectorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    editInspectorStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    editInspectorSuccess(state, action) {
      state.isLoading = false;
      state.inspectorData = action.payload;
    },

    editInspectorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    uploadFilesStart(state) {
      state.isUploading = true;
      state.uploadError = null;
    },
    uploadFilesSuccess(state, action) {
      state.isUploading = false;
      state.uploadedFiles = action.payload;
      state.uploadError = null;
    },
    uploadFilesFailure(state, action) {
      state.isUploading = false;
      state.uploadError = action.payload;
    },
    clearUploadedFiles(state) {
      state.uploadedFiles = [];
      state.uploadError = null;
    },

    fetchInspectorProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchInspectorProjectSuccess(state, action) {
      state.isLoading = false;
      state.inspectorData = action.payload.data;
      state.totalCount = action.payload.totalCount;
      state.error = null;
    },

    fetchInspectorProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setItemsPerPage(state, action) {
      state.itemsPerPage = action.payload;
    },
  },
});

export const {
  addInspectorStart,
  addInspectorSuccess,
  addInspectorFailure,
  fetchInspectorStart,
  fetchInspectorSuccess,
  fetchInspectorFailure,
  fetchInspectorDetailsStart,
  fetchInspectorDetailsSuccess,
  fetchInspectorDetailsFailure,
  setCurrentPage,
  setItemsPerPage,
  blockInspectorStart,
  blockInspectorFailure,
  blockInspectorSuccess,
  editInspectorStart,
  editInspectorFailure,
  editInspectorSuccess,
  uploadFilesStart,
  uploadFilesSuccess,
  uploadFilesFailure,
  clearUploadedFiles,

  fetchInspectorProjectStart,
  fetchInspectorProjectSuccess,
  fetchInspectorProjectFailure,
} = addInspectorSlice.actions;

export default addInspectorSlice.reducer;
